module.exports = __webpack_public_path__ + "static/media/rfb_testimonial3_mk.c3247cbe.jpg";